export default "__VITE_ASSET__DlQm505Q__"